import type { TFunction } from "i18next";
import type { TourStep } from "../TourProvider";
import { queryTourTarget } from "../utils/queryTourTarget";

/**
 * Tour configuration for Service Request Details
 * (/service-request/:requestID)
 */
export const serviceRequestDetailsTour = (t: TFunction): TourStep[] => [
  {
    title: t("Tour_SRDetails_Welcome_Title"),
    description: t("Tour_SRDetails_Welcome_Description"),
    target: () => queryTourTarget("sr-details-header"),
    placement: "bottom",
  },
  {
    title: t("Tour_SRDetails_Status_Title"),
    description: t("Tour_SRDetails_Status_Description"),
    target: () => queryTourTarget("sr-status"),
    placement: "bottom",
  },
  {
    title: t("Tour_SRDetails_Review_Title"),
    description: t("Tour_SRDetails_Review_Description"),
    target: () => queryTourTarget("sr-review"),
    placement: "left",
  },
  {
    title: t("Tour_SRDetails_Comments_Title"),
    description: t("Tour_SRDetails_Comments_Description"),
    target: () => queryTourTarget("sr-comments"),
    placement: "top",
  },
];
